$(document).ready(function() {
  $('.content-drawer--content').appendTo('#ContentDrawerContent')
  $('.content-drawer--trigger').on('click', function() {
    $('#ContentDrawer').scrollTop(0);
    var id = $(this).attr('content-drawer-trigger')
    $('.content-drawer--content').hide();
    $('.content-drawer--content[content-drawer-id="' + id + '"]').show()
    
    $('body').addClass('content-drawer-open');
  });

  $('#ContentDrawerOverlay, .content-drawer--close .icon').on('click', function() {
    $('body').removeClass('content-drawer-open');
  });
});
 


